<template>
  <footer class="footer">
    <img src="../assets/logo_sf.svg"/>
    <a href="#quellen">Quellen</a>
    <a href="#impressum">Impressum</a>
  </footer>
</template>

<script>

export default {
  name: 'Footer',
  //  components: {
  //   Impressum,
  // },
};
</script>

<style scoped lang="scss">
.footer {
  padding-bottom: 8px;
  margin-top: $padding-default;
  text-align: left;
}

h1 {
  font-size: 16px;
  text-transform: uppercase;
  line-height: 21.6px;
  color: $color-brand;
}

a {
  display: inline-block;
  margin-left: $padding-default;
  color: $color-link;
  text-decoration: underline;
}

img {
  margin-left: $padding-default;
  max-width: 140px;
}
</style>
